import React from 'react';
import styled from 'styled-components';

const Overlay = styled.div`
  position: fixed; inset: 0;
  background: rgba(0,0,0,0.5);
  display: flex; align-items: flex-end;
  z-index: 999;
`;

const Sheet = styled.div`
  background: white;
  border-radius: 20px 20px 0 0;
  padding: 20px 24px 40px;
  width: 100%;
  text-align: center;
`;

const Title = styled.h2`
  font-size: 18px; font-weight: 700;
  color: #1a1a1a; margin: 16px 0 8px;
`;

const Subtitle = styled.p`
  font-size: 14px; color: #666;
  line-height: 1.5; margin-bottom: 24px;
`;

const PrimaryBtn = styled.button`
  width: 100%;
  background: #D32F2F;
  color: white;
  border: none;
  border-radius: 100px;
  padding: 16px;
  font-size: 16px; font-weight: 600;
  cursor: pointer;
`;

const ImageWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 16px;
`;

const Icon = styled.img`
  width: 80px;
  height: 80px;
  object-fit: contain;
`;

interface Props {
  visible: boolean;
  onClose: () => void;
  onPickAnotherDoctor: () => void;
}

const DoctorTimeoutModal: React.FC<Props> = ({ visible, onClose, onPickAnotherDoctor }) => {
  if (!visible) return null;

  return (
    <Overlay>
      <Sheet style={{ position: 'relative' }}>
        <ImageWrapper>
          <Icon src='/images/doctor_no_response.svg' alt="Medical Warning" />
        </ImageWrapper>

        <Title>Dokter Belum Memberikan Tanggapan</Title>
        <Subtitle>
          Anda dapat tetap menunggu atau memilih dokter lain agar konsultasi dapat dilanjutkan.
        </Subtitle>

        <PrimaryBtn onClick={onPickAnotherDoctor}>
          Pilih Dokter Lain
        </PrimaryBtn>
      </Sheet>
    </Overlay>
  );
};

export default DoctorTimeoutModal;
